import styled from "styled-components";

export const TextareaContainer = styled.div`
	margin-bottom: 2em;
`;
